// extracted by mini-css-extract-plugin
export var root = "a6ce52820847e429f13dfeea1d354639-css";
export var icon = "_034e355a4ddec02a5ca6a0bd398a6ed9-css";